import { useNavigate, useParams } from 'react-router-dom';
import AdminSidebar from './AdminSidebar';
import GameMatch from './GameMatch';
import AdminMessageInbox from './AdminMessageInbox';
import AdminMatchRequestInbox from './AdminMatchRequestInbox';
import '../css/GameMatchControlPage.css';

function GameMatchControlPage() {
  const { groupId } = useParams();
  const navigate = useNavigate();
  const selectedGroupId = Number(groupId);

  return (
    <main className="gmc-page admin-shell-with-sidebar">
      <AdminSidebar active="game-control" groupId={selectedGroupId} />
      <AdminMessageInbox groupId={selectedGroupId} />
      <AdminMatchRequestInbox groupId={selectedGroupId} />
      <header className="gmc-header">
        <div className="gmc-hero-copy">
          <button type="button" onClick={() => navigate('/dashboard')}>← ภาพรวม</button>
          <p>🏸 MATCH CONTROL</p>
          <h1>จัดแมตช์และควบคุมสนาม</h1>
          <small>เลือกผู้เล่น สร้างคิว และติดตามสนามในหน้าจอเดียว</small>
        </div>
        <div className="gmc-group-badge"><small>ก๊วนที่กำลังจัดการ</small><b>Group #{selectedGroupId}</b><i>● พร้อมใช้งาน</i></div>
      </header>
      <section className="gmc-content"><GameMatch groupId={selectedGroupId} /></section>
    </main>
  );
}

export default GameMatchControlPage;
